module.exports = ['template', 'slot', 'component']
